module.exports = __webpack_public_path__ + "media/images/prediction/special/cycle/img_logo_publisher-bacdce42eda77dd88ddee1e5e20e5368.jpg";